var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBlueBank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.45532 10.5182H25.538L25.5579 7.52817L15.0132 3L4.45532 7.47514V10.5182ZM24.0297 8.99999H5.97681V8.4895L15.0132 4.65746L24.0297 8.52928V8.99999ZM4.4686 21.0464V25.4818H3V27H27V25.4818H25.5248V21.0464H22.462V11.9436H20.9471V21.0464H17.9967V11.9436H16.4818V21.0464H13.5248V11.9436H12.0099V21.0464H8.9868V11.9436H7.47189V21.0464H4.4686ZM24.0099 22.5647V25.4818H5.98347V22.5647H24.0099Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBlueBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BlueBank.919e8c809c94f75d836b699fe2e2afeb.svg";